import { ViewStyle, TextStyle } from "react-native"
import { color, spacing, typography } from "../../theme"

/**
 * Container style
 */
export const VIEW: ViewStyle = {
  minWidth: 230,
  paddingHorizontal: spacing[4],
}

/**
 * Label text style
 */
export const TEXT: TextStyle = {
  fontFamily: typography.primary.regular,
  color: color.text,
  fontSize: 18,
}
